import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../../rootReducer';

interface FileRepertoire {
  database?: string;
  ensemble?: string;
  ensemble2?: string;
  experiment?: string;
  frequency?: string;
  model?: string;
  variables?: string[];
}

const initialState: FileRepertoire = {
};

const fileRepertoireSlice = createSlice({
  name: 'fileRepertoire',
  initialState,
  reducers: {
    updateDatabase(state, action: PayloadAction<{database: FileRepertoire['database']}>) {
      const { database } = action.payload;
      state.database = database;
    },
    updateEnsemble(state, action: PayloadAction<{ensemble: FileRepertoire['ensemble']}>) {
      const { ensemble } = action.payload;
      state.ensemble = ensemble;
    },
    updateEnsemble2(state, action: PayloadAction<{ensemble2: FileRepertoire['ensemble2']}>) {
      const { ensemble2 } = action.payload;
      state.ensemble2 = ensemble2;
    },
    updateExperiment(state, action: PayloadAction<{experiment: FileRepertoire['experiment']}>) {
      const { experiment } = action.payload;
      state.experiment = experiment;
    },
    updateFrequency(state, action: PayloadAction<{frequency: FileRepertoire['frequency']}>) {
      const { frequency } = action.payload;
      state.frequency = frequency;
    },
    updateModel(state, action: PayloadAction<{model: FileRepertoire['model']}>) {
      const { model } = action.payload;
      state.model = model;
    },
    updateVariables(state, action: PayloadAction<{variables: FileRepertoire['variables']}>) {
      const { variables } = action.payload;
      state.variables = variables;
    },
  },
});

export const {
  updateDatabase,
  updateEnsemble,
  updateEnsemble2,
  updateExperiment,
  updateFrequency,
  updateModel,
  updateVariables,
} = fileRepertoireSlice.actions;

export default fileRepertoireSlice.reducer;

export const selectDatabase = (state: RootState) => {
  const { database } = state.fileRepertoire;
  return database;
};

export const selectEnsemble = (state: RootState) => {
  const { ensemble } = state.fileRepertoire;
  return ensemble;
};

export const selectEnsemble2 = (state: RootState) => {
  const { ensemble2 } = state.fileRepertoire;
  return ensemble2;
};

export const selectExperiment = (state: RootState) => {
  const { experiment } = state.fileRepertoire;
  return experiment;
};

export const selectFrequency = (state: RootState) => {
  const { frequency } = state.fileRepertoire;
  return frequency;
};

export const selectModel = (state: RootState) => {
  const { model } = state.fileRepertoire;
  return model;
};

export const selectVariables = (state: RootState) => {
  const { variables } = state.fileRepertoire;
  return variables;
};

export const selectSingleVariable = (state: RootState) => {
  const { variables } = state.fileRepertoire;

  if (variables == null || variables.length < 1) {
    return undefined;
  }

  if (variables.length > 1) {
    throw new Error(`Unexpected variables length: ${variables.length}`);
  }

  return variables[0];
};
